import React, { useState } from 'react';
import styled from 'styled-components';
import { Link, Loading, MessagePlugin } from 'tdesign-react';
import { isVoid } from '@/utils/common';
import yesPng from './images/check-circle.png';
import noPng from './images/x-circle.png';

/**
 * @typedef {import("./type").Props} Props
 */

/**
 * 输入框校验包装
 * @param {Props} props
 * @returns
 */
export default function ValidateWrapper({ children, onValidate, allowEmpty, ...others }) {
  const [loading, setLoading] = useState(false);
  const [isVerified, setIsVerified] = useState();

  const handleClick = async (event) => {
    event.preventDefault();
    if (loading) {
      return;
    }
    try {
      setLoading(true);
      setIsVerified(null);
      if (!allowEmpty && isVoid(others.value)) {
        MessagePlugin.warning('请先输入');
        return;
      }
      const result = await onValidate(others.value);
      if (isVoid(result)) {
        return;
      }
      setIsVerified(true);
    } catch (error) {
      setIsVerified(false);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const node = React.cloneElement(children, {
    style: {
      flex: 1,
      minWidth: 0,
    },
    suffix: (
      <Link onClick={handleClick} hover='color' theme='primary'>
        <Loading loading={loading} size='small'>
          校验
        </Loading>
      </Link>
    ),
    ...others,
  });
  return (
    <Root>
      {node}
      {!isVoid(isVerified) && <Icon $yes={isVerified} />}
    </Root>
  );
}

const Root = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.div`
  width: 20px;
  height: 22px;
  background-image: url(${(props) => (props.$yes ? yesPng : noPng)});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: 4px;
`;
